import { PayLayout } from '@components/templates';
import { lazyWithReload } from '@shared/react/lazyWithReload';
import { Route } from 'react-router-dom';

import {
  apiPaymentPath,
  apiPaymentPendingActionPath,
  apiPaymentProcessingPath,
  apiPaymentSuccessPath,
} from './urls';

const ApiPayment = lazyWithReload(() =>
  import('./pages/ApiPayment').then((m) => ({
    default: m.ApiPayment,
  }))
);

const ApiPaymentSuccess = lazyWithReload(() =>
  import('./pages/ApiPaymentSuccess').then((m) => ({
    default: m.ApiPaymentSuccess,
  }))
);

const ApiPaymentProcessing = lazyWithReload(() =>
  import('./pages/ApiPaymentProcessing').then((m) => ({
    default: m.Container,
  }))
);

const ApiPaymentPendingAction = lazyWithReload(() =>
  import('./pages/ApiPaymentPendingAction').then((m) => ({
    default: m.Container,
  }))
);

export const ApiPaymentRoutes = (
  <>
    <Route element={<PayLayout />}>
      <Route path={apiPaymentPath} element={<ApiPayment />} />
      <Route path={apiPaymentSuccessPath} element={<ApiPaymentSuccess />} />
      <Route path={apiPaymentProcessingPath} element={<ApiPaymentProcessing />} />
      <Route path={apiPaymentPendingActionPath} element={<ApiPaymentPendingAction />} />
      <Route path="/api-pay/test" element={<ApiPayment />} />
    </Route>
  </>
);

export default ApiPaymentRoutes;
